export enum SimpleGridRowStyleType {
  Bold = 'bold',
  Italic = 'italic',
}
